import Image from 'next/image';
import {forwardRef} from 'react';
import PropTypes from 'prop-types';

import Box from "@mui/material/Box";
import Link from '@mui/material/Link';

import {paths} from "src/routes/paths";
import {RouterLink} from 'src/routes/components';


// ----------------------------------------------------------------------

const Logo = forwardRef(({disabledLink = false, sx, square = false, height = 40, width = 160, ...other}, ref) => {
  const squareLogo = (
   <Box
    sx={{...sx}}
   >
     <Image
       alt="Kuliguli"
       src="/logo/fofoo_square.svg"
       height={height}
       width={height}
       priority
       fetchPriority="high"
     />
   </Box>
  );

  const logo = (
    <Box
      sx={{...sx}}
    >
      <Image
        alt="Kuliguli"
        src="/logo/fofoo.svg"
        height={height}
        width={width}
        priority
        fetchPriority="high"
      />
    </Box>
  );

  if (disabledLink) {
    return square ? squareLogo : logo;
  }

  return (
    <Link component={RouterLink} href={paths.homepage} sx={{display: 'contents'}}>
      {square ? squareLogo : logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  square: PropTypes.bool,
  sx: PropTypes.object,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default Logo;
